import cryptojs from 'crypto-js';


export default {
    //加密
    encrypt(key, content) {
        try {  //秘钥需要32位数，不足补空格
            if (key.length > 32) {
                key = key.substring(0, 32)
            } else if (key.length < 32) {
                key = (key + Array(32).join(' ')).substring(0, 32);//不足16位数，补空格
            }
            let keystr = cryptojs.enc.Utf8.parse(key);
            let ivStr = cryptojs.enc.Utf8.parse(key.substring(0, 16));//iv:偏移量，mode===ECB时，不需要iv
            let srcs = cryptojs.enc.Utf8.parse(content);
            let encrypted = cryptojs.AES.encrypt(srcs, keystr, { mode: cryptojs.mode.ECB, padding: cryptojs.pad.Pkcs7 });
            return encrypted.toString();
        } catch (err) {
            console.log("encrypt" + err)
            return "";
        }
    },
    //解密
    decrypt(key, content) {
        try {
            //秘钥需要32位数，不足补空格
            if (key.length > 32) {
                key = key.substring(0, 32)
            } else if (key.length < 32) {
                key = (key + Array(32).join(' ')).substring(0, 32);//不足16位数，补空格
            }
            let keystr = cryptojs.enc.Utf8.parse(key);
            let ivStr = cryptojs.enc.Utf8.parse(key.substring(0, 16));//iv:偏移量，mode===ECB时，不需要iv
            let decrypted = cryptojs.AES.decrypt(content, keystr, { mode: cryptojs.mode.ECB, padding: cryptojs.pad.Pkcs7 });
            return cryptojs.enc.Utf8.stringify(decrypted).toString();
        } catch (err) {
            console.log("decrypt" + err)
            return "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/Common/cryptojs.js